import { memo } from 'react';
import {
    ICON_MATCH_EVENT,
    IPlayer,
    MATCH_EVENT,
} from '@zmedia/bm-soccer-ui/interface';
import {
    Element,
    Icon,
    Level,
    List,
    RouterLink,
} from '@zmedia/bm-soccer-ui/components';
import { URL_SOCCER_PAGE } from '@zmedia/bm-soccer-ui/modules/shared';
import { Avatar } from '@zmedia/bm-soccer-ui/modules/shared/components/avatar';
import { EventPlayer } from '../event';
import styles from './style.module.scss';

export function OfficialList({ players = [] }: { players: IPlayer[] }) {
    return (
        <List className={styles['column-list']}>
            {players.map((player: any, index: number) => {
                return (
                    <List.Item key={index}>
                        <Level>
                            <Level.Side align="left">
                                <RouterLink
                                    to={`${URL_SOCCER_PAGE.SUBPATH}${player.path}`}
                                    title={player.name}
                                >
                                    <Avatar
                                        avatar={player.avatar}
                                        name={player.name}
                                    >
                                        <EventPlayer events={player.events} />
                                    </Avatar>
                                    <Element className={styles['player-info']}>
                                        {player.shirtNumber > 0 && (
                                            <Element
                                                className={styles['shirt']}
                                            >
                                                {player.shirtNumber
                                                    .toString()
                                                    .padStart(2, '0')}
                                            </Element>
                                        )}
                                        <Element>{player.shortName}</Element>
                                    </Element>
                                </RouterLink>
                            </Level.Side>
                            <Level.Side align="right">
                                <Element className={styles['bagdes-container']}>
                                    {player?.events?.map((event: any) => (
                                        <Icon
                                            icon={
                                                Object.assign(
                                                    {},
                                                    ICON_MATCH_EVENT,
                                                    {
                                                        SUBSTITUTION: 'sub-out',
                                                    }
                                                )[MATCH_EVENT[event.type.id]]
                                            }
                                            key={event.minuteLabel}
                                        />
                                    ))}
                                </Element>
                            </Level.Side>
                        </Level>
                    </List.Item>
                );
            })}
        </List>
    );
}
export default memo(OfficialList);
